import { Button, Stack } from "@mui/material";
import { useTitle } from "../../../hooks/title";

export const NotFound = () => {
  useTitle("Page not found · Imagio Color Finder");

  return (
    <Stack alignItems="center" spacing={2}>
      <h1>404</h1>
      <h2>Page not found</h2>
      <p>The page you wanted to reach could not be found.</p>
      <Button variant="contained" href="/">
        Back to Start Page
      </Button>
    </Stack>
  );
};
